import React from 'react'
import { useNavigate } from 'react-router-dom'
import case1Thumb from '../../assets/projects/Facset AARAMBH 2023/DSC00819.jpg'
import case2Thumb from '../../assets/projects/MassMutual Sangam/DSC06588.jpg'
import case3Thumb from '../../assets/projects/Rimini Street 10 Years Celebrations/DSC01127.jpg'


const CaseStudyCards = () => {
 
  const navigate = useNavigate()

  const caseStudies = [
    {
      title: "Aarambh",
      client: "Factset",
      thumbnail: case1Thumb
    },
    {
      title: "Sangam",
      client: "MassMutual India",
      thumbnail: case2Thumb
    },
    {
      title: "Decode The Decade",
      client: "Rimini Street India",
      thumbnail: case3Thumb
    },
  ]

  return (
        <div>
          <h3 className='text-3xl font-mosk600 pl-3'>All Case Studies</h3>
            <div className='grid grid-cols-6 justify-center gap-6 ' >
              {
              caseStudies.map((c, i)=>{ 
                  return(
                    <div  data-aos="fade-up" data-aos-duration={800 + (i*150)} key={i} onClick={()=> navigate(`/casestudy/${i+1}`)} className='col-span-6 md:col-span-3 lg:col-span-2 flex flex-col gap-2 hover:drop-shadow-sm p-3 cursor-pointer rounded-md hover:bg-[#e0e0e0a8]'>
                      {/* <img className='h-[25vh] md:h-[20vh] lg:h-[30vh] w-full rounded-md' src={c.thumbnail} alt="" /> */}
                      <div className='h-[25vh] md:h-[20vh] lg:h-[30vh] w-full rounded-md bg-cover bg-center no-repeat' style={{background: `url(${c.thumbnail})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat:'no-repeat'}} ></div>
                      <div>
                        <h3 className='text-lg lg:text-xl font-mosk600' >{c.title}</h3>
                        <p className='text-md lg:text-md' >Client: <span>{c.client}</span></p>
                      </div>
                    </div>
                  )
              })
              }
            </div>
        </div>
  )
}

export default CaseStudyCards
